import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=f06298ea"
import script from "./FormCard.vue?vue&type=script&lang=ts"
export * from "./FormCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports